import { render, staticRenderFns } from "./CancelReasonDialog.vue?vue&type=template&id=393c09a6&scoped=true&"
import script from "./CancelReasonDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./CancelReasonDialog.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CancelReasonDialog.vue?vue&type=style&index=0&id=393c09a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c09a6",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QIcon});qInstall(component, 'directives', {ClosePopup});
